import { __awaiter } from "tslib";
import React, { useEffect } from 'react';
import LabSimService from '../services/LabSimService';
import { T } from '@testout/labsim-ui-atomics';
import '@testout/labsim-ui-atomics/dist/index.css';
export default function Registration(props) {
    const [dynamicRegistration, setDynamicRegistration] = React.useState(null);
    useEffect(() => {
        const id = new URLSearchParams(props.location.search).get('id');
        const fetchDynamicRegistration = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield LabSimService.getDynamicRegistration(id);
            setDynamicRegistration(data);
            console.log(data);
        });
        if (id)
            fetchDynamicRegistration();
    }, [props.location]);
    const confirmRegistration = () => __awaiter(this, void 0, void 0, function* () {
        const data = yield LabSimService.postDynamicRegistration(dynamicRegistration === null || dynamicRegistration === void 0 ? void 0 : dynamicRegistration.dynamicRegistrationId);
        setDynamicRegistration(data);
    });
    useEffect(() => {
        if ((dynamicRegistration === null || dynamicRegistration === void 0 ? void 0 : dynamicRegistration.status) === 'Registered') {
            const closeMessage = { subject: 'org.imsglobal.lti.close' };
            // Does not work in Canvas
            (window.opener || window.parent).postMessage(closeMessage, '*');
        }
    }, [dynamicRegistration]);
    return (React.createElement("div", null,
        (dynamicRegistration === null || dynamicRegistration === void 0 ? void 0 : dynamicRegistration.status) !== 'Registered' && (React.createElement(React.Fragment, null,
            React.createElement("h1", null, "Confirm Registration"),
            React.createElement("p", null,
                "Please confirm that you are registering for ", dynamicRegistration === null || dynamicRegistration === void 0 ? void 0 :
                dynamicRegistration.campusName),
            React.createElement(T.Button, { variation: T.ButtonVariation.Primary, automationId: 'confirmRegistrationButton', onClick: confirmRegistration }, "Register"))),
        React.createElement("div", null,
            React.createElement("p", null, (dynamicRegistration === null || dynamicRegistration === void 0 ? void 0 : dynamicRegistration.message) && React.createElement("span", null, dynamicRegistration.message)),
            (dynamicRegistration === null || dynamicRegistration === void 0 ? void 0 : dynamicRegistration.status) === 'Registered' && (React.createElement("span", null, "Registration successful. You may now close this dialog and confirm the settings.")))));
}
//# sourceMappingURL=Registration.js.map